<template>
	<div>
		<div class="row divide">
			<div class="columns medium-3">
				<h4>Platform Fees</h4>
			</div>
			<div class="columns medium-9">
				<p>You can choose to pass on or absorb the platform fees. By absorbing payments you'll get paid faster and you can turn on features like Payment Secures Booking for 100% online payments.</p>


				<p v-if="passOnDisabled">You are <strong>absorbing</strong> the Platform Fee</p>
				<p v-else>You are <strong>passing on</strong> the Platform Fee</p>
			</div>

		</div>

		<div class="row divide collapse">
			<div class="columns small-4 text-right">
				<h5 v-bind:class="{ disabled: passOnDisabled }">Pass On Fees</h5>
			</div>

			<div class="columns small-4 text-center">
<!-- 				<i class="fa fa-spinner fa-pulse fa-lg fa-fw" v-if="loading"></i>	
				<div class="switch round" v-else>
				  <input id="platform_fees" type="radio" name="platform_fees" v-model="absorbChargesTransformed" :value="absorbCharges">
				  <label for="platform_fees" v-on:click="toggleSetting"></label>
				</div>	 -->	

				<AbsorbPaymentsToggle @update-absorb="getSettingValue" />
			</div>

			<div class="columns small-4 text-left">
				<h5 v-bind:class="{ disabled: absorbDisabled }">Absorb Fees</h5>
			</div>
		</div>

	</div>
</template>



<script>
import AbsorbPaymentsToggle from './../clientSettings/AbsorbPaymentsToggle';

import { mapGetters } from 'vuex';
export default {
	name: 'ClientPaymentsBookingFee',
	data () {
		return  {
			loading: false,
			status: ''
		}
	},
	computed : {
		// ...mapGetters([
		// 	'absorbCharges'
		// ]),

		absorbCharges: {
			get() {
				return this.$store.getters.absorbCharges
			},
			set(value) {
				this.$store.commit('SET_PLATFORM_FEE_SETTINGS', value)
			}
		},

		absorbChargesTransformed : {
			get() {
				if(this.absorbCharges == "0") {
					return false;
				} else {
					return 1;
				}
			},
			set() {
				// this.toggleSetting();
			}
		},

		passOnDisabled () {
			if(this.absorbCharges == "0") {
				return false;
			} else {
				return true;
			}			
		},

		absorbDisabled () {
			if(this.absorbCharges == "1") {
				return false;
			} else {
				return true;
			}			
		}

	},

	methods: {
		toggleSetting(setting) {
			this.loading = true;
			this.$store.dispatch('UPDATE_PLATFORM_FEES_SETTING')
				.then( () => this.loading = false);

		},

		getSettingValue (value) {
			this.absorbCharges = value;
		}
	},

	components: {
		AbsorbPaymentsToggle
	},

	created () {

	}


};
	
</script>



<style scoped>
.disabled {
	color: #b4bcca;
}

	
</style>